import { Button } from "@/components/ui/button";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { useAssessment } from "@/context/AssessmentContext";
import { process } from "@/data/content";

export default function ProcessSection({ light = false, withCta = true }) {
  const { openAssessment } = useAssessment();
  return (
    <section className={`${light ? "bg-navy" : "bg-mist"} py-24 lg:py-32`} data-testid="process-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          light={light}
          eyebrow="Our Process"
          title="A Clear Path From Setup to Growth"
          subtitle="Six practical steps that take your property from evaluation to ongoing digital growth."
        />

        <div className="mt-16 grid gap-x-8 gap-y-10 md:grid-cols-2 lg:grid-cols-3">
          {process.map((p, i) => (
            <Reveal key={p.step} delay={i * 0.08} className="relative">
              <div className="flex items-start gap-5">
                <span className={`font-serif text-5xl font-bold leading-none ${light ? "text-white/15" : "text-sky/40"}`}>{p.step}</span>
                <div>
                  <h3 className={`font-serif text-xl font-semibold ${light ? "text-white" : "text-navy"}`}>{p.title}</h3>
                  <p className={`mt-2 text-sm leading-relaxed ${light ? "text-white/70" : "text-slate-600"}`}>{p.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {withCta && (
          <Reveal className="mt-16 text-center">
            <Button onClick={openAssessment} data-testid="process-cta" className={`rounded-full px-8 py-6 text-base font-semibold transition-transform duration-200 hover:scale-[1.03] ${light ? "bg-sky text-navy hover:bg-sky-light" : "bg-navy text-white hover:bg-navy-800"}`}>
              Start With a Property Assessment
            </Button>
          </Reveal>
        )}
      </div>
    </section>
  );
}
